import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  mergeDeepLeft,
  clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import DynamicFormList from '../../common/DynamicFormList';
import '../../css/forms/default-forms.css';
import {
  basic as fields,
  contacts,
} from './fields';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import { addVendor } from '../../api/vendors';

export class VendorAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: clone(fields),
    };
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      const processedData = processFields(this.state.fields);
      this.props.saveForm(processedData);
    }
    return false;
  }

  cancel() {
    this.props.redirectToVendors();
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);

    if (typeof field === 'object') {
      // FIX: add support of multiple levels
      stateClone.fields[field[0]][field[2]] = newObject;
    } else {
      stateClone.fields[field] = newObject;
    }

    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  render() {
    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/vendors', icon: 'person_pin', name: 'Vendors' },
          { icon: 'add_to_photos', name: 'Vendors Add' },
        ]} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            <b>Add Vendor</b>
          </div>
          <div className="card-block">
            <div className="col" style={{ paddingBottom: '40px' }}>
              <button className={'btn btn-danger btn-outline pull-right ml-3'} onClick={this.cancel}>
                <i className="fa fa-remove"></i>
                <span className="pl-1">Cancel</span>
              </button>
              <button className={'btn btn-success btn-outline pull-right'} onClick={this.submit}>
                <i className="fa fa-check"></i>
                <span className="pl-1">Save</span>
              </button>
            </div>

            <form onSubmit={this.submit}>
              <div className="col-12">
                <Input
                  field={this.state.fields['name']}
                  onChange={this.changeFormValue}
                />

                <DynamicFormList
                  list={this.state.fields['contacts']}
                  onChange={this.changeFormValue}
                  fields={contacts}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToVendors: () => {
      dispatch(push('/pages/vendors'));
    },
    saveForm: (data) => {
      addVendor(data)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorAdd);



// WEBPACK FOOTER //
// ./src/containers/VendorAdd/index.js